import { put, call, select, all } from 'redux-saga/effects'

import { snackbarActions } from 'reduxModules/actions/SnackbarActions'
import { passengerActions } from 'reduxModules/actions/PassengerActions'
import { companySelector, isPrexBusSelector } from 'reduxModules/selectors/UserSelectors'
import {
  phoneSelector,
} from 'reduxModules/selectors/BookFormSelectors'
import {
  bookingsIDsSelector,
} from 'reduxModules/selectors/PassengerSelectors'

import { handlePhoneNumber } from 'services/helpers'

import { rsf, firebase } from '../../firebase'

export function* getPassengerSaga(action) {
  const { responseSuccess, responseFailure } = action

  try {
    const phone = yield select(phoneSelector)
    const phoneNumber = handlePhoneNumber(phone)

    if (!phoneNumber) {
      yield put(responseFailure())

      return
    }

    yield put(passengerActions.checkPassengerBookings())

    const res = yield call(rsf.firestore.getDocument, `passengers/${phoneNumber}`)

    if (res.exists) {
      const isPrexBus = yield select(isPrexBusSelector)
      const company = yield select(companySelector)

      if (!isPrexBus && res.data().company !== company) {
        return yield put(responseFailure())
      }

      if (res.data().blacklistIDs && res.data().blacklistIDs.length) {
        yield put(snackbarActions.showSnackbar({
          type: 'error',
          message: 'Номер знаходиться у чорному списку!'
        }))
      }

      yield put(responseSuccess({ phone: res.id, ...res.data() }))
    } else {
      yield put(responseFailure())
    }
  } catch (err) {
    console.log(err)
    yield put(responseFailure())
    yield put(snackbarActions.showSnackbar({
      type: 'error',
      message: 'Сталась помилка під час завантаження інформації про пасажира!'
    }))
  }
}

export function* getPassengerBookingsSaga(action) {
  const { responseSuccess, responseFailure } = action

  try {
    const bookingsIDs = yield select(bookingsIDsSelector)

    const res = yield all(
      bookingsIDs.map(id => call(rsf.firestore.getDocument, `bookings/${id}`))
    )

    const resFiltered = res.filter(resItem => resItem.exists)

    if (!resFiltered.empty) {
      const bookings = []

      resFiltered.forEach(booking => bookings.push({ id: booking.id, ...booking.data() }))

      yield put(responseSuccess(bookings))
    } else {
      yield put(responseFailure())
    }
  } catch (err) {
    console.log(err)
    yield put(responseFailure())
    yield put(snackbarActions.showSnackbar({
      type: 'error',
      message: 'Сталась помилка під час завантаження бронювань пасажира!'
    }))
  }
}

export function* setPassengerBookingSaga(action) {
  const { responseSuccess, responseFailure, data: { bookingId, phone } } = action

  try {
    const phoneNumber = handlePhoneNumber(phone)

    if (!phoneNumber || !bookingId) {
      yield put(responseFailure())

      return
    }

    yield call(
      rsf.firestore.setDocument,
      `passengers/${phoneNumber}`,
      {
        lastModified: firebase.firestore.FieldValue.serverTimestamp(),
        bookingsIDs: firebase.firestore.FieldValue.arrayUnion(bookingId),
      },
      { merge: true }
    )

    yield put(responseSuccess())
  } catch (err) {
    console.log(err)
    yield put(responseFailure())
    yield put(snackbarActions.showSnackbar({
      type: 'error',
      message: 'Сталась помилка під час завантаження запису бронювання пасажира!'
    }))
  }
}

export function* setPassengerSaga(action) {
  const { responseSuccess, responseFailure, data: { phone, firstName, lastName } } = action

  try {
    const company = yield select(companySelector)
    const phoneNumber = handlePhoneNumber(phone)

    if (!phoneNumber) {
      yield put(responseFailure())

      return
    }

    yield call(
      rsf.firestore.setDocument,
      `passengers/${phoneNumber}`,
      {
        firstName,
        lastName,
        company
      },
      { merge: true }
    )

    yield put(responseSuccess())
  } catch (err) {
    console.log(err)
    yield put(responseFailure())
    yield put(snackbarActions.showSnackbar({
      type: 'error',
      message: 'Сталась помилка під час завантаження запису пасажира!'
    }))
  }
}

export function* checkPassengerBookingsSaga(action) {
  const { responseSuccess, responseFailure } = action

  try {
    const phone = yield select(phoneSelector)
    const phoneNumber = handlePhoneNumber(phone)
    const checkedPassengerBookings = []

    const res = yield call(rsf.firestore.getDocument, `passengers/${phoneNumber}`)
    const bookingsIDs = res.data().bookingsIDs

    if (!bookingsIDs) {
      return put(responseSuccess())
    }

    const bookingsGet = yield all(
      bookingsIDs.map(booking => call(rsf.firestore.getDocument, `bookings/${booking}`))
    )

    bookingsGet.forEach(booking => booking.exists ? checkedPassengerBookings.push(booking.id) : null)

    yield call(rsf.firestore.setDocument,
      `passengers/${phoneNumber}`,
      { bookingsIDs: checkedPassengerBookings },
      { merge: true }
    )

    yield put(responseSuccess())
  } catch (err) {
    console.log(err)
    yield put(responseFailure())
  }
}



// WEBPACK FOOTER //
// ./src/reduxModules/sagas/PassengerSagas.js